import { useEffect, useState } from "react";

// Asks the backend whether AI writing (ChatGPT) is set up: an active OpenAI Application Key with a value.
// Returns null while checking, then true/false. Pass the page's own _Api (admin and POS use different ones).
// Checked once per mount, so adding a key elsewhere is picked up the next time the page opens.
export const useAiStatus = (_Api) => {
  const [aiActive, setAiActive] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await _Api({}, "api/v1/APP/ai/status");
        if (!cancelled) setAiActive(Boolean(res?.data?.active));
      } catch (err) {
        if (!cancelled) setAiActive(false);
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return aiActive;
};
